import * as Types from '../../../../generated/base-types';

import { gql } from 'apollo-angular';
import { Injectable } from '@angular/core';
import * as Apollo from 'apollo-angular';
export type DimensionFragment = { __typename?: 'Dimension', id: string, name: string, nameDe?: string | null, nameEn?: string | null, nameFr?: string | null, nameIt?: string | null, position: number, categories: Array<{ __typename?: 'Category', id: string, name: string, nameDe?: string | null, nameEn?: string | null, nameFr?: string | null, nameIt?: string | null, position: number, customIdentifier?: string | null, dimension: { __typename?: 'Dimension', id: string } }> };

export type CategoryFragment = { __typename?: 'Category', id: string, name: string, nameDe?: string | null, nameEn?: string | null, nameFr?: string | null, nameIt?: string | null, position: number, customIdentifier?: string | null, dimension: { __typename?: 'Dimension', id: string } };

export type LoadDimensionsQueryVariables = Types.Exact<{
  poolId: Types.Scalars['ID'];
}>;


export type LoadDimensionsQuery = { __typename?: 'Query', pool: { __typename?: 'Pool', dimensions: Array<{ __typename?: 'Dimension', id: string, name: string, nameDe?: string | null, nameEn?: string | null, nameFr?: string | null, nameIt?: string | null, position: number, categories: Array<{ __typename?: 'Category', id: string, name: string, nameDe?: string | null, nameEn?: string | null, nameFr?: string | null, nameIt?: string | null, position: number, customIdentifier?: string | null, dimension: { __typename?: 'Dimension', id: string } }> }> } };

export const CategoryFragmentDoc = gql`
    fragment Category on Category {
  id
  name
  nameDe
  nameEn
  nameFr
  nameIt
  position
  customIdentifier
  dimension {
    id
  }
}
    `;
export const DimensionFragmentDoc = gql`
    fragment Dimension on Dimension {
  id
  name
  nameDe
  nameEn
  nameFr
  nameIt
  position
  categories {
    ...Category
  }
}
    ${CategoryFragmentDoc}`;
export const LoadDimensionsDocument = gql`
    query LoadDimensions($poolId: ID!) {
  pool(id: $poolId) {
    dimensions {
      ...Dimension
    }
  }
}
    ${DimensionFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class LoadDimensionsGQL extends Apollo.Query<LoadDimensionsQuery, LoadDimensionsQueryVariables> {
    document = LoadDimensionsDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }